import React, { useRef, useEffect, useState } from "react";
import { Link, NavLink, useNavigate } from 'react-router-dom';
import './orderhistory.scss';
import { Helmet } from "react-helmet";
import Icon from '@mdi/react';
import { mdiArrowLeft, mdiClipboardTextSearchOutline, mdiLoading } from '@mdi/js';
import CustomFunction from '../../components/customFuction';
import axios from "axios";
import { HANDLE_401_ERROR, ORDER_HISTORY_LOAD } from "../../constants/actionTypes";
import agent from "../../agent";
import { useDispatch } from "react-redux";
import Modal from 'react-modal';
import { useForm, Controller, set } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';
import closeIcon from "../../Views/TuneUp/CloseIcon.svg";
import Footer from "../../components/Footer/Footer";


function OrderHistory(props) {


  const listInnerRef = useRef();
  const dispatch = useDispatch();
  const [data, setData] = useState([]);

  const [currPage, setCurrPage] = useState(1);
  const [prevPage, setPrevPage] = useState(0);
  const [userList, setUserList] = useState([]);
  const [lastList, setLastList] = useState(false);
  const [isLoading, setLoading] = useState(true)
  const [isPagingLoading, setPagingLoading] = useState(false)
  const [offsetValue, setOffsetValue] = useState(0);
  const [profileInfo, setProfileInfo] = useState("");
  const [isButtonLoading, setButtonLoading] = useState(false);
  const [paymentChargeSuccess, setPaymentChargeSuccess] = useState([]);
  const [paymentModalIsOpen, setPaymentModalISOpen] = useState(false);
  const [paymentUpdateModel, setPaymentUpdateModel] = useState(false);
  const [paymentChargeError, setPaymentChargeError] = useState('');
  const [paymentTipData, setPaymentTipData] = useState('');
  const [paymentChargeId, setPaymentChargeId] = useState([]);
  const [paymentCompleteSuccess, setPaymentCompleteSuccess] = useState('');
  const [paymentCompleteError, setPaymentCompleteError] = useState('');
  const [paymentInfoError, setPaymentInfoError] = useState("");
  const [responseData, setResponseData] = useState(null);
  const navigate = useNavigate();
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);

  const validationSchema = Yup.object({
    order_payment_tip: Yup.string().nullable()
  });

  const formOptions = { resolver: yupResolver(validationSchema) };

  const { register, handleSubmit, setValue, control, reset, formState: { errors } } = useForm(formOptions);

  // const customStyles1 = {
  //   content: {
  //     top: 47,
  //     left: 0,
  //     right: 0,
  //     bottom: 0,
  //     margin: '0 auto',
  //     background: 'rgba(255, 255, 255, 0.95)',
  //     maxWidth: '550px',
  //     padding: '30px 15px 0',
  //     width: '100%',
  //     maxHeight: '460px',
  //     borderRadius: '30px',
  //     border: '0.5px solid #000000'
  //   }
  // };


  const customStyles = {
    content: {
      top: '40%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      transform: 'translate(-50%, -50%)',
      background: '#fff',
      maxWidth: '400px',
      padding: '30px 15px',
      width: '90%'
    },
  };


  const paymentModalIsCloseModal = (charge, index) => {
    setPaymentModalISOpen(false);
    // paymentComplete1(charge, index);
  }

  const getProfileInfo = async () => {
    // setLoading(true)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log("accesstoken", accessToken)
    // const refreshToken = JSON.parse(localStorage.getItem("refresh_token"));
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + '/user', config);
      setProfileInfo(data?.results?._id);


    }

    catch (error) {
      HANDLE_401_ERROR(error.response?.status);
     // console.log(error)
      // setLoading(false);
    }
  }


  const newColorCode = [
    { status: 'confirmed', color: '#24AD65' },
    { status: 'completed', color: '#24AD65' },
    { status: 'cancelled', color: '#E94E4E' },
    { status: 'open', color: '#FFB400' },
  ]




  useEffect(() => {
    getProfileInfo();

  }, []);
  useEffect(() => {
    if (offsetValue >= 0 && profileInfo) {
      setLoading(true);
      fetchData();
    }

    if (profileInfo) {
      getPaymentChargeInfo();
    }
  }, [profileInfo]);

  useEffect(() => {
    if (paymentChargeSuccess && paymentChargeSuccess.length > 0) {
      setPaymentModalISOpen(true);
    } else {
      setPaymentModalISOpen(false);
    }
  }, [paymentChargeSuccess]);


  const fetchData = async () => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    // console.log(accessToken)
    setLoading(true);
    try {

      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const offsets = offsetValue;
      const response = await axios.get(
        process.env.REACT_APP_RIDEDOC_API_ROOT + `order/all/customer?id=${profileInfo}&offset=${parseInt(offsets == 0 ? offsets : offsets - 1)}`, config
      )
    //  console.log("order list", response?.data?.results);
      // const newOrders = response.data?.results.map((order) => {
      //   const color = newColorCode.find((item) => item.status === order.status)?.color;
      //   return { ...order, color };
      // });
      const newOrders = response.data?.results;

      const uniqueData = newOrders.filter((newOrder) => {
        return !data.find((order) => order._id === newOrder._id);
      });

      setData((prevData) => [...prevData, ...uniqueData]);

      // if (orderList.length === 0) {
      //     setNoData(true);
      // }

      setOffsetValue((prevOffset) => prevOffset + 10);
      // setData(response?.data?.results);
      setLoading(false);
      // if (data) {
      //   // setLastList(true);
      //   setPagingLoading(false);
      // }
      // else {
      //   setPagingLoading(true);
      // }


      // setPagingLoading(false)

    }
    catch (error) {
      HANDLE_401_ERROR(error.response?.status);
     // console.log(error)
      setLoading(false);
    }
  };

  const getPaymentChargeInfo = async () => {
    setLoading(true)
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },
      };
      const { data } = await axios.get(process.env.REACT_APP_RIDEDOC_API_ROOT + `payment/pending-charges/user/${profileInfo}`, config);
     // console.log("Pending charge data", data);
      setPaymentChargeSuccess(data?.results);
      setLoading(false)
    } catch (error) {
      HANDLE_401_ERROR(error.response?.status);
      setLoading(false)
     // console.log(error)
    }
  };

  const handleFormSubmit = async (data, charge, index) => {
   // console.log("data on submit", data);
    // console.log("selected payment charge", paymentChargeSuccess[index])

    let tip = paymentTipData;
    if (!tip) {
      tip = 0;
    }
    setButtonLoading(true)
    setPaymentInfoError('')
    setTimeout(() => {
      setPaymentUpdateModel(true);
    }, 2000)
    
    paymentComplete(charge, data, index, tip);
  }

  const paymentComplete = async (data, charge, index, tip) => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    setPaymentChargeId(paymentChargeSuccess[index].order)
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },

      };
      const val = {
        tip_cost: tip
      };
      // const userID = props?.common?.currentUser?.results?._id;
     // console.log("tip-payment", paymentTipData);

      const response = await axios.post(process.env.REACT_APP_RIDEDOC_API_ROOT + `payment/charge/${paymentChargeSuccess[index]._id}/complete`, val, config);
      // console.log("time slot response", response?.data?.results?.availabe_slots);
      // console.log("erroe-data", response?.data);
      setPaymentCompleteSuccess(response);    
        
     
      //  console.log(response?.data);
      setButtonLoading(false);
      setPaymentUpdateModel(true);
        setPaymentModalISOpen(false);

      // navigate('/order-details/' + paymentChargeSuccess[index].order);
    } catch (error) {
      setPaymentInfoError(error.response.data.message)
      setButtonLoading(false)
      setPaymentCompleteError(error);
      setPaymentModalISOpen(false);
      setPaymentUpdateModel(true);
      HANDLE_401_ERROR(error.response?.status);
     // console.log("payment charge complete error", error?.response?.data?.message);
    }
  }


  const paymentComplete1 = async (charge, index) => {
    const accessToken = JSON.parse(localStorage.getItem("access_token"));
    const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone.toString();
    try {
      const config = {
        headers: {
          "Content-Type": "application/json",
          'x-access-token': `${accessToken}`,
          'x-request-time': new Date().toString(),
          'x-request-timezone': timeZone
        },

      };
      const val = {
        tip_cost: '0'
      };
      // const userID = props?.common?.currentUser?.results?._id;
     // console.log("tip-payment on close", paymentTipData);
      const response = await axios.post(process.env.REACT_APP_RIDEDOC_API_ROOT + `payment/charge/${charge?._id}/complete`, val, config);
      // console.log("time slot response", response?.data?.results?.availabe_slots);
      setPaymentCompleteSuccess(response);
      setButtonLoading(false);
      // navigate('/order-details/' + paymentChargeSuccess[index].order);
    } catch (error) {
      setPaymentInfoError(error);
      setButtonLoading(false);
      HANDLE_401_ERROR(error.response?.status);
     // console.log("payment charge complete error", error);
    }
  }

  const handleInput = (e) => {
    setPaymentTipData(e.target.value);
  }

  function bookingModalIsCloseModal() {
    // setBookingModalISOpen(false);
    setPaymentUpdateModel(false);
    setPaymentModalISOpen(false);

    // navigate('/order-details/' + paymentChargeId);
  }

  const handleButtonClick = () => {
    setPaymentUpdateModel(false);
    setPaymentModalISOpen(false);
  }


  const onScroll = () => {
    if (listInnerRef.current) {
      const { scrollTop, scrollHeight, clientHeight } = listInnerRef.current;
      if (scrollTop + clientHeight === scrollHeight) {
        setCurrPage(currPage + 1);
      }
    }
  };


  const handleLoadClick = () => {

    fetchData();

  }

  // console.log("offset on click", offsetValue);
  // console.log("DATE", data);


  function dateFormat(dateString) {
    const date = new Date(dateString);
    const options = { month: 'short', day: '2-digit', year: 'numeric' };
    const formattedDate = date.toLocaleDateString('en-US', options);
    return formattedDate;
  }

  function isToday(date) {
    const today = new Date();
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  }

  function isYesterday(date) {
    const yesterday = new Date();
    yesterday.setDate(yesterday.getDate() - 1);
    return (
      date.getDate() === yesterday.getDate() &&
      date.getMonth() === yesterday.getMonth() &&
      date.getFullYear() === yesterday.getFullYear()
    );
  }

  const profileMenuBackground = require('../ProfileMenu/images/profile-menu-background.png')

  return isLoading ? (   //Checkif if is loading
    <div className="lds-ripple"><div></div><div></div></div>
  ) : (
    <div className='order-history-bg'>

      <div className='main' onScroll={onScroll} ref={listInnerRef}
      // style={{
      //   backgroundImage: `url('${profileMenuBackground}')`, backgroundRepeat: 'no-repeat',
      //   backgroundSize: '600px', backgroundPosition: 'center', height: '100%',
      //   marginBottom: '5rem', borderRadius: 0

      // }}
      >
        <Helmet>
          <title>RideDoc | Order History</title>
          <meta name="description" content="Mobile bike mechanics at your door step" />
        </Helmet>
        <div className='header-wrp'>
          <header>
            <div className="header-backic">
              <Link to="/home" className="header-backic-icon">
                <Icon path={mdiArrowLeft} size={'28px'} color="#222" />
              </Link>
            </div>
            <div className="order-history-header">
              <p className="header-mnutxt ">Order History</p>
            </div>
          </header>
        </div>
        <div className='main-wrapper order-history-main'>
          {(data.length > 0) ?
            <div className="order-history-wrp">
              <div className="order-history-list">
                <div className="order-history-item">
                  {/* {console.log("data length inside jsx", data.length)}
                  {console.log("data?.[0]?.results", data)}
                  {console.log("data after slice", data?.[0]?.results)} */}
                  {data.map((orderlist, index) => {
                    const orderDate = new Date(orderlist?.slot_date_time);
                    let text = '';
                    if (isToday(orderDate)) {
                      text = 'Today';
                    } else if (isYesterday(orderDate)) {
                      text = 'Yesterday';
                    } else {
                      text = dateFormat(orderDate); // Replace with your desired date formatting logic
                    }

                    return (
                      <div className='order-history-itemin' key={index} >
                        <Link to={"/order-details/" + orderlist?._id} state={{ orderdetails: orderlist }} className="order-history-item-link">
                          <div className="order-hisroy-img">
                            <img src={orderlist?.service?.image_url} alt="" />
                          </div>
                          <div className="order-hisroy-item-cnt">
                            <div className="order-history-description">
                              <h4>{orderlist?.plan?.display_name}</h4>
                              <div className="order-history-mech" style={{ color: "#000", fontWeight: 300, paddingTop: "0.1rem" }}>RideDoc: {orderlist?.mechanic?.first_name && orderlist?.mechanic?.last_name
                                ? `${orderlist.mechanic.first_name} ${orderlist.mechanic.last_name}`
                                : 'Not Assigned'}</div>
                            </div>
                            <div className="order-hisroy-item-stat" >
                              <span className="order-hisroy-item-stat-txt order-margin-top" style={{ background: CustomFunction.orderStatusFnColor(orderlist?.status), width: "5rem", height: "1.3rem", borderRadius: "0.25rem", padding: "5px" }}>{CustomFunction.orderStatusFn(orderlist?.status)}</span>
                              <span className="order-hisroy-item-date">{text}</span>
                            </div>

                          </div>
                        </Link>
                      </div>

                    )
                  })}


                  {isPagingLoading &&
                    <div className="page-loading">
                      <Icon path={mdiLoading} size={'36px'} color="#FF5F07" spin={0.5} />
                    </div>
                  }
                </div>
              </div>
            </div>
            :
            null
          }
          {!data.length ? (
            <div className="order-history-wrp" style={{ height: "80vh" }}>
              <div className="order-history-list">
                <div className='nonverify'>
                  <Icon path={mdiClipboardTextSearchOutline} size={'60px'} color="#ff5f07" />
                  <p className='nonverify-cnt'>Oops!, There is no order history details available.</p>
                </div>
              </div>
            </div>
          ) :
            null
          }
        </div>
      </div>
      <div className="footercontainer">
        {data.length >= 10 &&
          <button
            className="btn"
            style={{ width: '10rem' }}
            onClick={handleLoadClick}
          >
            Refresh
          </button>
        }

      </div>

      <Footer />
      {paymentModalIsOpen && (
        <>
          {paymentChargeSuccess.map((charge, index) => {
            const handleCloseModal = () => paymentModalIsCloseModal(charge, index);
            return (
              <Modal
                key={index}
                isOpen={paymentModalIsOpen}
                onRequestClose={handleCloseModal}
                shouldCloseOnOverlayClick={false}
                shouldCloseOnEsc={false}
                ariaHideApp={false}
                style={customStyles}
                // className="time-slot-popup"
                overlayClassName="modal-Overlay"
                contentLabel="bookingOrderTimeSlot"
              >
                <h3 style={{ textAlign: "center", fontSize: 20, paddingTop: 20 }}>Payment Confirmation</h3><br></br>
                <div className="rd-popup-hd rd-popup-hd-orderid">
                  Order No : {charge.ref_id}
                </div>
                <div className="rd-popup-hd rd-popup-hd-servicecost">
                  Service Cost : ${(charge?.total_service_adjustment_cost ?? 0).toFixed(2)}
                </div>

<div className="rd-popup-hd rd-popup-hd-partcost">
  Parts Cost : ${(charge?.parts_cost ?? 0).toFixed(2)}
</div>

<div className="rd-popup-hd rd-popup-hd-discount">
  Discount : -${(charge?.order?.promo_discount_amount ?? 0).toFixed(2)}
</div>

<div className="rd-popup-hd rd-popup-hd-tax">
  Tax ({charge?.state_tax_percentage ?? 0}%) : ${(charge?.state_tax_cost ?? 0).toFixed(2)}
</div>

<div className="rd-popup-hd rd-popup-hd-totcost">
  Total Cost : ${(charge?.customer_total_billing_cost ?? 0).toFixed(2)}
</div>
                {/* <div className="rd-popup-hd rd-popup-hd-orderid">
                  Order No : {charge.ref_id}
                </div> */}
                <div className='booking-wrp tips-popup'>
                  <div className='rd-popup-wrp' style={{display: "initial"}}>
                    {/* {console.log("order-success", paymentChargeSuccess)} */}
                    <section className="profile-info-sec-wrp" style={{marginLeft: "2rem", marginRight: "2rem"}}>
                      <div className="rd-popup-close">
                        <button className='reg-close' onClick={handleCloseModal}>
                          <img src={closeIcon} alt='close Icon' />
                        </button>

                      </div>
                      {/* {paymentChargeError && <span className='error'>{paymentChargeError}</span>}
                    {paymentChargeSuccess && <span className='success'>{paymentChargeSuccess}</span>} */}
                      <form onSubmit={handleSubmit((data) => handleFormSubmit(data, charge, index))}>


                        <div className="form-group-wrp">
                          <div className="row">
                            <div className="col">
                              <div className="form-group">
                              
                <label className="form-lbl form-lbl-profileinfo" htmlFor="order_payment_tip" style={{top: "-6px", color: "black", backgroundColor: "white"}}>Tips</label>
                              <input className="form-control form-height" type="text" defaultValue=""  {...register('order_payment_tip')} onInput={handleInput} name="order_payment_tip" id="order_payment_tip" />
                                {/* <input hidden className="form-control" {...register('payment_charge_id')} defaultValue={charge._id} type="text" name="payment_charge_id" id="payment_charge_id" />
                                <input readOnly className="form-control" style={{ marginBottom: 30 }} {...register('payment_charge_amount')} defaultValue={charge.customer_total_billing_cost} type="text" name="payment_charge_amount" id="payment_charge_amount" />
                                <label className="form-lbl form-lbl-payment" style={{ fontSize: 10 }} htmlFor="payment_charge_amount">Order Amount Payable</label>
                                <input className="form-control form-height" type="text" defaultValue=""  {...register('order_payment_tip')} onInput={handleInput} name="order_payment_tip" id="order_payment_tip" />
                                <label className="form-lbl form-lbl-profileinfo" htmlFor="order_payment_tip">Order Service Tip</label> */}
                              </div>
                              {errors.order_payment_tip &&
                                <div className="invalid-feedback">{errors?.order_payment_tip.message}</div>
                              }
                            </div>
                          </div>
                        </div>


                        {isButtonLoading ?
                          <div className="btn btn-primary">Loading...</div>
                          :
                          <button className="btn btn-primary" type="submit">Submit</button>
                        }
                      </form>
                    </section>
                  </div>
                </div>
              </Modal>


            )
          })};
        </>

      )
      }

      {
        paymentUpdateModel && (
          <>
            <Modal
              isOpen={paymentUpdateModel}
              onRequestClose={bookingModalIsCloseModal}
              shouldCloseOnOverlayClick={false}
              ariaHideApp={false}
              style={customStyles}
              overlayClassName="modal-Overlay"
              contentLabel="bookingOrderTimeSlot"
            >
              <div className='booking-wrp order-booking-time-popup'>
                <div className='rd-popup-wrp'>
                  <div className="rd-popup-hd">
                    {/* <div className="rd-popup-close">

                <button className='reg-close' onClick={bookingModalIsCloseModal}>
                  <Icon path={mdiClose} size={'15px'} color="#222" />
                </button>
              </div> */}
                  </div>
                  {paymentCompleteSuccess && (
                    <div className="rd-popup-content payment-message">
                      <p className="pb20">Payment Updated Successfully.</p>
                      <div className="ok-button" style={{ width: "4.5rem", margin: "0 auto" }}>
                        <button
                          className="btn btn-primary btn-update-ok"
                          onClick={handleButtonClick}
                        >
                          Ok
                        </button>
                      </div>
                    </div>
                  )}
                  {paymentCompleteError && (
                    <div className="rd-popup-content payment-message">
                      <p className="pb20">Payment Updated Failed.</p>
                      <div className="ok-button" style={{ width: "4.5rem", margin: "0 auto" }}>
                        <button
                          className="btn btn-primary btn-update-ok"
                          onClick={handleButtonClick}
                        >
                          Ok
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </Modal>
          </>
        )
      }
    </div>
  )
}


export default OrderHistory;
